import { useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { apiClient } from "../lib/apiClient";

export const useApiAuth = () => {
  const { logout } = useAuth();

  useEffect(() => {
    // Set up token expiration handler
    apiClient.setTokenExpirationHandler(() => {
      console.log("Token expired, logging out...");
      logout();
    });
  }, [logout]);
};
